<!-- 本科导师-首页-引导页 -->
<template>
  <div class='guide-mask'
       v-if='isShowMask'>
    <div class='guide-con'>
      <div class='guide-home'
           v-if='isShowHome'>
        <h3 class='title'><span>Home</span></h3>
        <div class='message'>
          <div class='message-con'>
            <span>Your to-do list is here</span>
            <a href='javascript:void(0)'
               @click="messageHome">I know</a>
          </div>
          <div class='trangle-top'></div>
        </div>
      </div>
      <div class='guide-mentee'
           v-if='isShowMentee'>
        <h3 class='title'><span>Mentee</span></h3>
        <div class='message'>
          <div class='message-con'>
            <span>Your mentee is here</span>
            <a href='javascript:void(0)'
               @click="messageMentee">I know</a>
          </div>
          <div class='trangle-top'></div>
        </div>
      </div>
      <div class='guide-personal'
           v-if='isShowPersonal'>
        <h3 class='title'>
          <img src='https://res.zailairen.com/tech/msp/mentor-avatar.svg' />
        </h3>
        <div class='message'>
          <div class='message-con'>
            <span>Your personal information is here</span>
            <a href='javascript:void(0)'
               @click="messagePersonal">I know</a>
          </div>
          <div class='trangle-top'></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 遮罩层隐藏标识
      isShowMask: false,
      // 首页引导显示标识
      isShowHome: false,
      // 学员引导显示标识
      isShowMentee: false,
      // 个人信息引导显示标识
      isShowPersonal: false
    }
  },
  computed: {},
  mounted () {
    this.isShowMask = true
    this.isShowHome = true
  },
  methods: {
    // 首页引导点击关闭
    messageHome () {
      this.isShowHome = false
      setTimeout(() => {
        this.isShowMentee = true
      }, 500)
    },
    // 学员引导点击关闭
    messageMentee () {
      this.isShowMentee = false
      setTimeout(() => {
        this.isShowPersonal = true
      }, 500)
    },
    // 个人信息引导点击关闭
    messagePersonal () {
      this.isShowPersonal = false
      this.isShowMask = false
      this.$emit('closeGuide')
    }
  }
}
</script>
<style lang='less' scoped>
.guide-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #e6eaf1;
  .guide-con {
    width: 1240px;
    padding: 0 20px;
    margin: 0 auto;
    position: relative;
    .guide-home {
      position: absolute;
      top: 36px;
      left: 238px;
      .message {
        width: 240px;
      }
    }
    .guide-mentee {
      position: absolute;
      top: 36px;
      left: 336px;
      .message {
        width: 220px;
      }
    }
    .guide-personal {
      position: absolute;
      top: 10px;
      right: 2px;
      .message {
        width: 300px;
        top: 100px;
        left: auto;
        right: 0;
        transform: translateX(0);
        .trangle-top {
          left: auto;
          right: 36px;
          transform: translateX(0);
        }
      }
    }
    h3 {
      width: 85px;
      height: 85px;
      border-radius: 85px;
      text-align: center;
      background: #fff;
      position: relative;
      span {
        display: inline-block;
        font-size: 18px;
        color: #323c47;
        letter-spacing: 0;
        text-align: center;
        line-height: 60px;
        font-weight: normal;
        border-bottom: 4px solid #4aa6ff;
      }
    }
    .message {
      position: absolute;
      top: 100px;
      left: 50%;
      width: 240px;
      height: 50px;
      background: rgb(73, 158, 254);
      border-radius: 8px;
      transform: translateX(-50%);
      color: #fff;
      padding: 9px 10px;
      .message-con {
        span {
          display: inline-block;
          font-size: 14px;
          margin-right: 10px;
        }
        a {
          display: inline-block;
          font-size: 12px;
          width: 64px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          color: #fff;
          border: 1px solid #ffffff;
          border-radius: 4px;
        }
      }
      .trangle-top {
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-bottom: 8px solid rgb(73, 158, 254);
        position: absolute;
        top: -16px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
